export default "__VITE_ASSET__c38aaa97__"